import {Breadcrumb, Card, Flex, Space, Tabs} from "antd";
import {FiChevronRight} from "react-icons/fi";
import {breadcrumbItemRender} from "../../services/utils";
import {Text} from "../../theme/typography";
import {TYPOGRAPHY_SIZES} from "../../theme/constants";
import React from "react";
import {LuLayoutDashboard} from "react-icons/lu"

const items = [
    {
        path: '/',
        title: (<><LuLayoutDashboard/> <span>Projects</span></>),
    },
    {
        path: '/settings',
        title: 'Settings'
    }
];

const Settings = () => {
    return (
        <>
            <Space direction="vertical" size={"middle"} style={{width: '100%'}}>
                <Breadcrumb
                    separator={<FiChevronRight/>}
                    items={items}
                    itemRender={breadcrumbItemRender}
                />

                <Flex vertical={true}>
                    <Text weight={700} size={TYPOGRAPHY_SIZES.H5}>Settings</Text>
                </Flex>

                <Card>
                    <Tabs
                        defaultActiveKey="1"
                        items={[
                            {
                                label: 'Users',
                                key: '1',
                                children: <></>,
                            },
                        ]}
                    />
                </Card>
            </Space>
        </>
    )
}

export default Settings;